import React from 'react';
import {NextPage} from 'next';
import HtmlHead from "../src/components/headerAndFooter/HtmlHead";
import WaveLayout from "../src/layouts/WaweLayout";
import * as styled from "../src/components/subpageHeroArea/ApplicationSubpageStyled";
import CareerApplication from "../src/components/careerApplication/CareerApplication";
import BreadcrumbComp from "../src/components/breadcrumb/BreadcrumbComp";
import GeneralFormCareerComp from "../src/components/generalForm/GeneralFormCareerComp";
import SubpageHeroArea from "../src/components/subpageHeroArea/SubpageHeroArea";
import TextArea from "../src/components/textArea/TextArea";
import ButtonComp from "../src/components/buttons/buttonComp/buttonComp";
import {NavigationURLs} from "../src/functions/NavigationFunctions";

const DijitalSatisData = {
    title: 'Dijital Satış ve Operasyon Uzmanı',
    text: '<p> Firmamıza ait internet sitemiz için üyelere hizmet sağlayacak ve üyelik sürecinin ve sonrasında oluşacak ihtiyaçların karşılanması ve değerlendirilmesi için Dijital Satış ve Operasyon Uzmanı arıyoruz. </p> <p class="fw-bold"> Aranan özellikler </p> <ul> <li> Üniversitelerin ilgili bölümlerinden mezun </li> <li> MS Office programlarını iyi seviyede kullanabilen </li> <li> Raporlama ve sunum becerileri gelişmiş </li> <li> Dijital operasyon alanında en az 2-3 yıl deneyimli </li> <li> Google Analytics kullanabilen </li> <li> Temel düzeyde Html5, Javascript, CSS hakkında bilgi sahibi </li> <li> İngilizce bilen </li> <li> İnsan ilişkilerinde başarılı, takım çalışmasına yatkın </li> <li> Çözüm odaklı, değişim ve gelişime açık, bulunduğu ortama katma değer yaratan </li> <li> İletişimi güçlü </li> <li> Esnek ve yoğun çalışma saatlerine uyum sağlayabilen </li> <li> Erkek adaylar için askerlik hizmetini tamamlamış </li> </ul> <p class="fw-bold"> Çalışma süresi </p> <p> Tam zamanlı </p>'
}

const KariyerBasvuru: NextPage = () => {
    const breadcrumbDijitalKariyer = [
        { label: 'Pembe Panjur', link: NavigationURLs.landing },
        { label: 'Kariyer', link: NavigationURLs.career},
        { label: 'Dijital Satış ve Operasyon Uzmanı'}
    ];

    return (
        <React.Fragment>
            <HtmlHead pageTitle="Kariyer Başvuru | Pembe Panjur"
                        description="Pembe Panjur kariyer başvuru sayfası ile ilgili detaylara sayfamızdan ulaşabilirsiniz."
            />
            <WaveLayout
                backgroundColor={'#D2147D'}
                loginButtonText={false}
                sloganOne={''}
                sloganTwo={''}
                homeButton={true}
                className={'career_page'}
                extraChildren={
                    <React.Fragment>
                        <styled.ApplicationSubpage
                            className={'mobile-bgc-white'}
                        >
                            <styled.ApplicationSubpageContainer className={'mb-0'}>
                                <styled.ApplicationSubpageWrapper>
                                    <BreadcrumbComp/>
                                    <CareerApplication title={DijitalSatisData.title} text={DijitalSatisData.text} breadcrumb={breadcrumbDijitalKariyer}/>
                                </styled.ApplicationSubpageWrapper>
                                <styled.ApplicationSubpageWrapper>
                                    <GeneralFormCareerComp title={'Başvuruyu gönder'} textareaTitle={'Hakkında'}
                                                     textareaPlaceholder={'Lütfen kısaca hakkınızda bilgilendirme yapın.'}
                                                     careerUpload={true} pageTitle={'dijital_satis'}/>
                                </styled.ApplicationSubpageWrapper>
                            </styled.ApplicationSubpageContainer>
                        </styled.ApplicationSubpage>
                    </React.Fragment>
                }
            >
                <SubpageHeroArea desktopHidden={true}>
                    <styled.CareerApplicationHeroAreaContent>
                        <TextArea>
                            <h2>
                                Pembe Panjur KARİYER
                            </h2>
                        </TextArea>
                        <ButtonComp fullWidth={true} backgroundColor={'#FFFFFF'} visible={false} uppercase={true} textColor={false} url={'#'}>
                            <React.Fragment>
                                Dijital Satış ve Operasyon Uzmanı
                            </React.Fragment>
                        </ButtonComp>
                    </styled.CareerApplicationHeroAreaContent>
                </SubpageHeroArea>
            </WaveLayout>
        </React.Fragment>
    );
}

import { checkAuthAndRedirect } from '../src/utils/authHelper';
export const getServerSideProps = async (context: any) => {
    return await checkAuthAndRedirect(context);
};


export default KariyerBasvuru;
